<template>
	<el-drawer size="35%" :title="title" :visible.sync="dialogVisible" :modal-append-to-body="false" direction="rtl" :wrapperClosable="wrapperClosable"
		class="customer-drawer-common bind-wechat">
		<el-form ref="form" :model="form" :rules="formRules" label-width="150px">
			<el-form-item :label="currentForm.name + '：'" prop="name">
				<el-input :placeholder="'请输入'+currentForm.name" v-model="form.name" clearable>
				</el-input>
			</el-form-item>
			<el-form-item :label="currentForm.id + '：'" prop="id">
				<el-input :placeholder="'请输入'+currentForm.id" v-model="form.id" clearable>
				</el-input>
			</el-form-item>
			<el-form-item :label="currentForm.secret + '：'" prop="secret">
				<el-input :placeholder="'请输入'+currentForm.secret" v-model="form.secret" clearable>
				</el-input>
			</el-form-item>
			<el-form-item :label="currentForm.encodingAESKey + '：'" prop="encodingAESKey">
				<el-input :placeholder="'请输入'+currentForm.encodingAESKey" v-model="form.encodingAESKey" clearable>
				</el-input>
			</el-form-item>
			<el-form-item label="URL：" class="copy_value" v-show="form.url">
				<el-input v-model="form.url" disabled></el-input>
				<el-button type="text" @click="onCopy(form.url)">复制</el-button>
			</el-form-item>
			<el-form-item label="令牌(token)：" class="copy_value" v-show="form.url">
				<el-input v-model="form.token" disabled></el-input>
				<el-button type="text" @click="onCopy(form.token)">复制</el-button>
			</el-form-item>
		</el-form>
		<div class="tips" v-show="form.url && form.token">
			<p>1. 请将URL和Token绑定在微信公众平台后台【开发-基本配置】中</p>
			<p>2.【开发-基本配置】中，消息加解密方式 请选择 安全模式</p>
		</div>
		<div class="footer" v-if="form.url && form.token">
			<el-button type="primary" size="mini" @click="onFinish" >完 成</el-button>
		</div>
		<div class="footer" v-else>
			<el-button @click="dialogVisible = false" size="mini">取 消</el-button>
			<el-button type="primary" size="mini" @click="onSave" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}
			</el-button>
		</div>
		
	</el-drawer>
</template>

<script>
	import {copyTextToClipboard} from '@/utils/functions.js'
	import {getWechatTokenUrl} from '@/api/system.js'
	export default {
		data(){
			return {
				formMsg:[
					{type:1,key:'绑定微信公众号',name:'微信名称',id:'开发者ID(AppID)',secret:'开发者密码(AppSecret)',encodingAESKey:'消息加解密密钥(encodingAESKey)'},
					{type:2,key:'绑定微信小程序',name:'小程序名称',id:'APP(小程序)ID',secret:'APPSecret (小程序秘钥)',encodingAESKey:'消息加解密密钥(encodingAESKey)'}
				],
				currentForm:'',
				title:'绑定微信公众号',
				loading:false,
				dialogVisible:false,
				form:{
					name:'',
					id:'',
					secret:'',
					encodingAESKey:'',
					url:'456',
					token:'token'
				},
				formRules:{
					name:[{ required: true, message: '名称不能为空', trigger: 'blur' }],
					id:[{ required: true, message: 'AppID不能为空', trigger: 'blur' }],
					secret:[{ required: true, message: 'AppSecret不能为空', trigger: 'blur' }],
					encodingAESKey:[{ required: true, message: 'encodingAESKey不能为空', trigger: 'blur' }]
				},
				row_data:'',
				wrapperClosable:false
			}
		},
		methods:{
			onSave(){
				this.$refs.form.validate(valid => {
					if(valid){
						this.loading = true
						let params = {
							  "appname": this.form.name,
							  "brand": this.row_data?.appidConfig?.grantBrand,
							  "encodingAESKey": this.form.encodingAESKey,
							  "id": this.row_data.id || '1',
							  "appId":this.form.id,
							  "messageHandleType": this.row_data.messageHandleType,
							  "msgEncryptionModel": "安全",
							  "skillGroup": this.row_data?.appidConfig?.grantSkillgroup,
							  "type": this.row_data.type,
							  "imuri": this.row_data.imuri,
							  "appSecret": this.form.secret,
						}
						this.$api.getWechatSystemAuthDev(params).then(res => {
							this.loading = false
							if(res.errcode == 0) {
								this.$message.success('绑定成功');
								this.form.url = res.data.url;
								this.form.token = res.data.token;
							}
						}).catch(err => {
							this.loading = false
						})
					}
				})
			},
			onFinish(){
				this.dialogVisible = false;
				this.$emit('getList')
			},
			openBind(row){
				this.row_data = row;
				this.dialogVisible = true;
				this.wrapperClosable = false;
				this.currentForm = this.formMsg.filter(el => el.type == row.type)[0];
				this.form.name = row.appname;
				this.title = this.currentForm.key;
				this.form.id = '';
				this.form.secret = '';
				this.form.encodingAESKey = '';
				this.form.url = '';
				this.form.token = '';
				
			},
			openCopyBind(row){
				getWechatTokenUrl(row.appid).then(res => {
					if(res.errcode == 0){
						this.currentForm = this.formMsg.filter(el => el.type == row.type)[0];
						this.title = this.currentForm.key;
						this.form.name = row.appname;
						this.form.secret = row.appidConfig.appSecret;
						this.form.id = row.appid;
						this.form.encodingAESKey = row.appidConfig.encodingAesKey;
						this.form.url = res.data.url;
						this.form.token = res.data.token;
						this.dialogVisible = true;
						this.wrapperClosable = true;
					}
				})
			},
			onCopy(value){
				copyTextToClipboard(value,()=>{
					this.$message.success("复制成功")
				})
			}
		}
	}
</script>

<style lang="scss">
	.bind-wechat {
		.el-form-item--medium .el-form-item__label {
			line-height: 16px;
		}
		.tips {
			font-size: 12px;
			color: #F29522;
			padding-left: 120px;
			margin-bottom: 15px;
		}
		.copy_value {
			.el-form-item__content {
				display: flex;
				.el-button {
					margin-left: 5px;
				}
			}
			
		}
	}
</style>
